
export async function fetchVideoStats(videoId) {
  const accountId = process.env.REACT_APP_CLOUDFLARE_ACCOUNT_ID;
  const token = process.env.REACT_APP_CLOUDFLARE_TOKEN;

  try {
    const res = await fetch(
      `https://api.cloudflare.com/client/v4/accounts/${accountId}/stream/${videoId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const data = await res.json();

    if (!data.success) {
      console.error("Cloudflare Stream API error:", data.errors);
      return null;
    }

    return {
      views: data.result.playback?.views ?? 0,
      duration: data.result.duration ?? 0,
      status: data.result.status?.state ?? "unknown"
    };
  } catch (err) {
    console.error("Cloudflare Stream fetch failed:", err);
    return null;
  }
}
